import type { QuotaInfo } from "@/types";
import { request, requestVoid } from "@/services/api/request";

export interface KnowledgeBaseFile {
  id: string;
  filename: string;
  mimeType: string;
  fileSizeBytes: number;
  status: "indexing" | "ready";
  createdAt: string;
}

export interface KnowledgeBaseData {
  files: KnowledgeBaseFile[];
  quota: QuotaInfo;
}

export async function listKnowledgeBase(): Promise<KnowledgeBaseData> {
  return request<KnowledgeBaseData>("/knowledge-base");
}

export async function uploadKnowledgeBaseFile(file: File): Promise<void> {
  const formData = new FormData();
  formData.append("file", file);
  await requestVoid("/knowledge-base", { method: "POST", body: formData });
}

export async function deleteKnowledgeBaseFile(fileId: string): Promise<void> {
  await requestVoid(`/knowledge-base/${fileId}`, { method: "DELETE" });
}
